import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import ProjectLayout from "../ProjectLayout";
import ErrorBoundary from "../ErrrorBoundry";
import { getLocalStorageItem } from "../Utils";
import { useSelector } from "react-redux";

function ProtectedAuth() {
  const location = useLocation();
  const profileDetail = useSelector((state) => state.B2B.profileDetail);
  const navigate = useNavigate();
  const isAuthenticated = () => {
    const user = getLocalStorageItem("isLoggedIn");
    return user;
  };

  useEffect(() => {
    if (
      location.pathname !== "/kycStatus" &&
      location.pathname !== "/Report_main" &&
      location.pathname !== "/Report/wallet" &&
      location.pathname !== "/Report/loginHistory" &&
      location.pathname !== "/Report/nsdl" &&
      location.pathname !== "/Report/uti" &&
      location.pathname !== "/Report/dmt" &&
      location.pathname !== "/Report/bbps" &&
      location.pathname !== "/Report/xpressPayout" &&
      location.pathname !== "/Report/upiPayments" &&
      location.pathname !== "/Report/fund-request" &&
      location.pathname !== "/Report/aadharpay" &&
      location.pathname !== "/Report/balance-enquirey" &&
      location.pathname !== "/Report/recharge" &&
      location.pathname !== "/Report/payout" &&
      location.pathname !== "/Report/cash-transaction" &&
      location.pathname !== "/Report/bankVerify" &&
      location.pathname !== "/Report/eko/aadhar" &&
      location.pathname !== "/Report/eko/pan" &&
      location.pathname !== "/Report/eko/bankVerify" &&
      location.pathname !== "/Report/eko/cms" &&
      location.pathname !== "/Report/eko/credit-card" &&
      location.pathname !== "/Report/eko/bbps-offline" &&
      location.pathname !== "/Report/" &&
      location.pathname !== "/Report/Mini-statement" &&
      location.pathname !== "/Report/cash-withdrawl" &&
      location.pathname !== "/Report/commission_member" &&
      location.pathname !== "/dashboard" &&
      location.pathname !== "/memberList" &&
      location.pathname !== "/add-member" &&
      location.pathname !== "/debit_credit_fund" &&
      location.pathname !== "/bbps" &&
      location.pathname !== "/hotel" &&
      location.pathname !== "/bus" &&
      location.pathname !== "/flights" &&
      location.pathname !== "/express-payout" &&
      location.pathname !== "/payout/verification" &&
      location.pathname !== "/dmt/remitters" &&
      location.pathname !== "/panServices" &&
      location.pathname !== "/coming-soon" &&
      location.pathname !== "/uti" &&
      location.pathname !== "/offlineservice" &&
      location.pathname !== "/fundRequest" &&
      location.pathname !== "/personal-info" &&
      location.pathname !== "/not-available" &&
      location.pathname !== "/Report/fund-request" &&
      location.pathname !== "/eko/payout" &&
      location.pathname !== "/eko/qr" &&
      location.pathname !== "/eko/static/qr" &&
      location.pathname !== "/eko/bank-verify" &&
      location.pathname !== "/eko/pan-verify" &&
      location.pathname !== "/eko/cms" &&
      location.pathname !== "/eko/express-payout" &&
      location.pathname !== "/eko/aadhar-verify" &&
      location.pathname !== "/eko/bbps" &&
      location.pathname !== "/eko/bbps-offline" &&
      location.pathname !== "/ekoOnboardStatus" &&
      location.pathname !== "/not-available" &&
      location.pathname !== "/eko/credit-card" &&
      location.pathname !== "/eko/dmt-service" &&
      location.pathname !== "/banking/aeps-eko-onboard" &&
      location.pathname !== "/banking/aeps-eko-ekyc" &&
      location.pathname !== "/eko/dmt/addCustomers" &&
      location.pathname !== "/eko/payout" &&
      location.pathname !== "/eko/aeps-service" &&
      location.pathname !== "/doMerchantOnboard" &&
      location.pathname !== "/fundRequest" &&
      location.pathname !== "/personal-info" &&
      location.pathname !== "/Report/fund-request" &&
      location.pathname !== "/recharge" &&
      location.pathname !== "/recharge2" &&
      location.pathname !== "/checkOut" &&
      location.pathname !== "/checkOut2" &&
      location.pathname !== "/payment-service" &&
      location.pathname !== "/BbpsOffline1/bawana_infra" &&
      location.pathname !== "/BbpsOffline1/lease_part_payment" &&
      location.pathname !== "/BbpsOffline1/part_payment" &&
      location.pathname !== "/give-topup" &&
      location.pathname !== "/give_top_up_balanceTransfer" &&
      location.pathname !== "/fund-request" &&
      (profileDetail.digio_kyc === "0" ||
        profileDetail.digio_kyc === "2" ||
        profileDetail.digio_kyc === "3")
    ) {
      navigate("/kycStatus");
    }
    if (
      location.pathname === "/eko/payout" &&
      location.pathname === "/eko/qr" &&
      location.pathname === "/eko/static/qr" &&
      location.pathname === "/eko/bank-verify" &&
      location.pathname === "/eko/pan-verify" &&
      location.pathname === "/eko/cms" &&
      location.pathname === "/eko/express-payout" &&
      location.pathname === "/eko/aadhar-verify" &&
      location.pathname === "/eko/bbps" &&
      location.pathname === "/eko/bbps-offline" &&
      location.pathname === "/eko/credit-card" &&
      location.pathname === "/eko/dmt-service" &&
      location.pathname === "/eko/dmt/addCustomers" &&
      location.pathname === "/eko/payout" &&
      location.pathname === "/eko/aeps-service"
    ) {
      navigate("/ekoOnboardStatus");
    }
  }, [location]);

  return isAuthenticated() ? (
    <>
      {" "}
      <ProjectLayout>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </ProjectLayout>
    </>
  ) : (
    <>
      <Navigate to="/" replace />
    </>
  );
}
export default ProtectedAuth;
